/*
These functions make sure WordPress
and Foundation play nice together.
*/
var forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]);
  }
};

jQuery(document).ready(function() {
	var mainHeaderHeight = jQuery('#main-header').height()
	jQuery('.content').css('margin-top', mainHeaderHeight)
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


/*
	var btn = document.querySelectorAll(".custom-button");
	forEach(btn, function (index, value) {
		var btnTimeout;

		value.addEventListener("mouseover", function() {
			var dataHover = jQuery(this).data('hover');
			clearTimeout(btnTimeout);
			if (dataHover){
				this.textContent = dataHover;
				jQuery(this).addClass('hovered');
			}
		});

		value.addEventListener("mouseout", function() {
			var dataOriginal = jQuery(this).data('original');
			var unhoveredButton = this;
			if (dataOriginal){
				btnTimeout = setTimeout(function(){
					unhoveredButton.textContent = dataOriginal;
					jQuery(unhoveredButton).removeClass('hovered');
				}, 1000);
			}
		})

	});
  */

});
